export default __webpack_public_path__ + "static/media/japan_bridge.65b1daf1.jpg";